import React, { Component } from "react"
import { withStyles } from '@material-ui/core/styles';
import { TextField, Select, MenuItem, InputBase, InputAdornment, IconButton, FormControl, FormHelperText } from "@material-ui/core"
import Save from "../../../../assets/img/svg/save.svg"
import { getProjectStatus } from "../../../../actions/projectAction";
import { deleteproject } from "../../../../actions/AddNewProjectAction"
import Cancel from "../../../../assets/img/svg/cancel.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Delete from "../../../../assets/img/svg/delete.svg"
import del from "../../../../assets/img/svg/Del.svg"
import $ from "jquery"
import moment from "moment"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../_helpers/endpointService"

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

class DeleteProject extends Component {
    constructor(props) {
        super(props)
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            menu: true,
            isError1: false,
            ProjectId: 0,
            ProjectName: "",
            TypeProjectName: "",
        }
    };
    componentDidMount() {
        const { dispatch } = this.props;
        this.state.UserRole = localStorage.getItem("UserRoles")
        this.state.ProjectId = localStorage.getItem("DashId")
        this.state.ProjectName = localStorage.getItem("ProjectName")
        this.setState({})
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
        $("#Delete1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#DeleteProject1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#DeleteProject").removeClass("d-none");
        $("#DeleteProject").addClass("d-block");
        $("#DP .MuiListItemText-primary").addClass("fw-bolder");
        $("#DPL").addClass("active-color")
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        $("#DP .MuiListItemText-primary").removeClass("fw-bolder")
        $("#DPL").removeClass("active-color")
    }
    sidebar = () => {
        if (window.location.pathname == "/deleteproject/deleteproject") {
            this.props.navigate("/sidebareditproject");
        }
        else {
            this.props.navigate("/sidebaraddproject");
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

    };

    getProjectTypeName = (e) => {
        this.state.TypeProjectName = e.target.value;
        this.setState({})
    };

    AddCancel = () => {
        this.props.navigate(`/projectlist`)
    };

    DeleteItem = () => {
        this.deleteproject(this.state.ProjectId,this.state.UserRole)
        window.$("#exampleModal123").modal("hide");
        this.state.TypeProjectName = "";
        this.setState({})
    }

    deleteproject = (data,name) => {
        let apiUrl = API.ADDEDIT_PROJECT + data + '?modify=' + name;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
            data: data,
            // headers : {
            //   'content-type': 'application/json'
            // }
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate(`/projectlist`)
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                    // logOut();
                }
            });
    };

    render() {
        const { TypeProjectName, ProjectName } = this.state;
        let { classes, projectStatus, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-7  mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Delete" + "1"} className='textNaviIcon' primary="Delete Project" style={{ color: 'red' }} />
                                            <NavigateNextIcon id="Delete1" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5 ">
                                    <h4 className="pt-2">Delete Project</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {
                        this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center" width="20%"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel}></i></td>
                                        <td className="text-left" width="80%">
                                            <button className={`${classes.button}`} data-target="#exampleModal123" data-toggle="modal" disabled={this.state.TypeProjectName === this.state.ProjectName ? false : true}  ><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.TypeProjectName === this.state.ProjectName ? '' : '0.5' }}></img>&nbsp;Delete</button>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                            :
                            <>
                                <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center">
                                                <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel}></i></td>
                                            <td className="" width="" style={{ display: 'flex' }}>
                                                <button className={`${classes.button}`} data-target="#exampleModal123" data-toggle="modal" disabled={this.state.TypeProjectName === this.state.ProjectName ? false : true} ><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.TypeProjectName === this.state.ProjectName ? '' : '0.5' }} ></img>&nbsp;Delete</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </>
                    }
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">Delete Project</h6>}
                        <div className={this.state.isMobile ? "row mx-1" : "row mx-1 px-3 mt-4"}>
                            <div className={`row mt-2 mx-0 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-12 col-xl-12 mt-2 col-md-12 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : ""}`}>
                                    <label className="pt-2" style={{ fontSize: '14px' }}>Are you sure you want to delete the "<span className="fw-bold">{this.state.ProjectName}</span>" Project? All users in this project will immediately lose access.</label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-12 col-xl-12 col-md-12 ${this.state.isMobile ? "border-left border-right col-md-12 pt-2" : "col-12 col-sm-12  col-lg-12 col-xl-12 mt-2 col-md-12"}`}>
                                    <span lassName="pt-2 pb-4">To confirm this action, please type <span className="fw-bold">{this.state.ProjectName}</span>.</span>
                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2" : "col-md-4 pt-2"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.TypeProjectName}
                                        onChange={(e) => { this.getProjectTypeName(e) }}
                                        placeholder="Type Project Name"
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div style={{ margin: this.state.isMobile ? "auto" : "15px 45px" }}>
                        <div className="row px-4 mt-3">
                            {this.state.isMobile ? <></> : <h6 className="col-12">Delete Project</h6>}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-3">
                                <label style={{ fontSize: '14px' }}>Are you sure you want to delete the "<span className="fw-bold">{this.state.ProjectName}</span>" Project? All users in this project will immediately lose access.</label>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 pt-3">
                                <span >To confirm this action, please type <span className="fw-bold">{this.state.ProjectName}</span>.</span>
                                <div className="mt-2"></div>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={this.state.TypeProjectName}
                                    onChange={(e) => { this.getProjectTypeName(e) }}
                                    placeholder="Type Project Name"
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />
                            </div>
                        </div>
                    </div> */}
                </div>
                <div class="modal fade p-5 mt-5" id="exampleModal123" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} id="closemodal1" data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

DeleteProject.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DeleteProject))
);
